module.exports = __webpack_public_path__ + "static/media/cases_3d_05e.85c9232e.jpg";